import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserUtil } from '../utils/user.utils';

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private readonly authService: AuthService,
    private readonly userUtil: UserUtil
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean {
    if (this.authService.isAuthenticated()) {
      let route = 'news-list';
      if (this.userUtil.isFuncionarioProfile()) {
        route = 'users';
      }
      if (this.userUtil.isProfessorProfile()) {
        route = 'chat';
      }
      this.router.navigate([route]);
      return false;
    }
    return true;
  }
}
